import { useState } from 'react'

import { getNavMenuContent, NavMenuContentType } from '@hhgtech/hhg-components'
import { FooterInfoMarryBaby } from '@hhgtech/hhg-components/types'
import {
  cleanUpUndefined,
  formatCategory,
  formatHealthTool,
  formatHealthToolTypeCategory,
} from 'api/dataTransform'
import { PATHS } from 'api/paths'
import { callApi, getApiPath } from 'api/utils'
import { NavigatorLayout } from 'components/templates/navigatorLayout'
import HealthTools from 'container/health-tools'
import { LOCALE_SPECS } from 'interfaces/constants'
import {
  Category,
  CategoryHealthToolApi,
  HealthTool,
  HealthToolByCategory,
} from 'interfaces/types'
import { GetServerSideProps } from 'next'
import { useRouter } from 'next/router'
import { useIntl } from 'react-intl'

export type Props = {
  healthTools: HealthTool[]
  categories: Category[]
  sitename: string
  siteDomain?: string
  healthToolsByCategory: HealthToolByCategory[]
  footerMenu: FooterInfoMarryBaby
  dataNavMenuContent?: NavMenuContentType | null
}

const HealthToolsPage = ({
  dataNavMenuContent,
  sitename,
  healthTools,
  footerMenu,
}: Props) => {
  const [isTopBarAppears, setIsTopBarAppears] = useState(false)
  const { locale = 'vi-VN' } = useRouter()

  const { formatMessage: f } = useIntl()

  const onTopBarAppears = (b: boolean) => {
    setIsTopBarAppears(b)
  }

  return (
    <NavigatorLayout
      title={f(
        {
          id: 'healthToolsPage.seoTitle',
        },
        {
          siteName: sitename,
        },
      )}
      description={f({ id: 'HealthToolsPage.seoDescription' })}
      onTopBarAppears={onTopBarAppears}
      data-is-top-bar={isTopBarAppears}
      image={LOCALE_SPECS[locale].HOMEPAGE_IMAGE}
      SEOData={{
        seoType: 'article',
        schemaData: f({ id: 'healthToolsPage.seoSchema' }),
        isIndexable: true,
        hasNoAmp: true,
      }}
      footerMenu={footerMenu}
      dataNavMenuContent={dataNavMenuContent}
      activeMenuService="tools"
    >
      <HealthTools healthTools={healthTools} />
    </NavigatorLayout>
  )
}

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { query, locale } = ctx

  const siteName = LOCALE_SPECS[locale || 'vi-VN'].SITE_NAME_FORMATTED

  const [
    healthToolsData,
    categoriesData,
    healthToolsDataByCategories,
    footer,
    navMenuContent,
  ] = await Promise.all([
    callApi(getApiPath(PATHS.GET_ALL_HEALTH_TOOLS), 'GET'),
    callApi(getApiPath(PATHS.GET_ALL_CATEGORIES), 'GET'),
    callApi(getApiPath(PATHS.GET_HEALTH_TOOLS_BY_CATEGORY), 'GET'),
    callApi(getApiPath(PATHS.GET_DYNAMIC_FOOTER), 'GET'),
    getNavMenuContent('vi-VN_MB'),
  ])

  return {
    props: {
      query,
      locale,
      healthTools:
        healthToolsData?.data?.map((tool: HealthTool) =>
          formatHealthTool(tool),
        ) || [],
      healthToolsByCategory:
        (healthToolsDataByCategories &&
          healthToolsDataByCategories?.data.length > 0 &&
          healthToolsDataByCategories?.data?.map(
            (category: CategoryHealthToolApi) =>
              formatHealthToolTypeCategory(category),
          )) ||
        [],
      categories: categoriesData?.data?.map(formatCategory) || [],
      sitename: siteName,
      footerMenu: footer?.data ?? {},
      dataNavMenuContent: cleanUpUndefined(navMenuContent) || null,
    },
  }
}

export default HealthToolsPage
